module.exports = __webpack_public_path__ + "img/mall_img_miaosha_tr@3x.5ae6b7ff.png";